import {
  LayoutDashboard,
  TrendingUp,
  Search,
  Zap,
  Bot,
  MapPin,
  Users,
  BarChart3,
  Link2,
  Lightbulb,
  ClipboardList,
  FileEdit,
  FileText,
  Key,
  Settings,
  Database,
  DollarSign,
  ShieldCheck,
  type LucideIcon,
} from 'lucide-react'

export interface NavChild {
  id: string
  label: string
  path: string
  disabled?: boolean
  badge?: string
}

export interface NavGroup {
  name?: string // header du groupe (gris, non cliquable). Si absent = pas de header
  items: NavChild[]
}

export interface NavItem {
  id: string
  label: string
  icon: LucideIcon
  path?: string
  children?: NavChild[] // GARDER pour compatibilite temporaire
  groups?: NavGroup[] // nouveau - sous-elements groupes pour la section sidebar
  disabled?: boolean
  badge?: string
  adminOnly?: boolean
  comingSoon?: boolean // nouveau - grise dans le rail
}

export const MAIN_NAV: NavItem[] = [
  {
    id: 'overview',
    label: 'Accueil',
    icon: LayoutDashboard,
    path: '',
  },
  {
    id: 'rankings',
    label: 'Classements',
    icon: TrendingUp,
    path: 'rankings',
    children: [
      { id: 'rankings-overview', label: 'Apercu global', path: 'rankings' },
      { id: 'rankings-keywords', label: 'Mots-cles detailles', path: 'rankings/keywords' },
      { id: 'rankings-pages', label: 'Pages', path: 'rankings/pages' },
    ],
    groups: [
      {
        items: [
          { id: 'rankings-overview', label: 'Apercu global', path: 'rankings' },
          { id: 'rankings-keywords', label: 'Mots-cles detailles', path: 'rankings/keywords' },
          { id: 'rankings-pages', label: 'Pages', path: 'rankings/pages' },
        ],
      },
    ],
  },
  {
    id: 'audit',
    label: 'Audit',
    icon: Search,
    path: 'audit',
    children: [
      { id: 'audit-overview', label: 'Apercu global', path: 'audit' },
      { id: 'audit-errors', label: "Rapport d'erreurs", path: 'audit/errors' },
      { id: 'audit-pages', label: 'Pages crawlees', path: 'audit/pages' },
      { id: 'audit-resources', label: 'Ressources trouvees', path: 'audit/resources' },
      { id: 'audit-links', label: 'Liens trouves', path: 'audit/links' },
      { id: 'audit-checklist', label: 'Checklist SEO', path: 'audit/checklist' },
    ],
    groups: [
      {
        items: [
          { id: 'audit-overview', label: 'Apercu global', path: 'audit' },
          { id: 'audit-errors', label: "Rapport d'erreurs", path: 'audit/errors' },
          { id: 'audit-pages', label: 'Pages crawlees', path: 'audit/pages' },
          { id: 'audit-resources', label: 'Ressources trouvees', path: 'audit/resources' },
          { id: 'audit-links', label: 'Liens trouves', path: 'audit/links' },
          { id: 'audit-checklist', label: 'Checklist SEO', path: 'audit/checklist' },
        ],
      },
    ],
  },
  {
    id: 'performance',
    label: 'Performance',
    icon: Zap,
    path: 'performance/vitals',
    children: [
      { id: 'perf-vitals', label: 'Core Web Vitals', path: 'performance/vitals' },
      { id: 'perf-pagespeed', label: 'PageSpeed', path: 'performance/pagespeed' },
    ],
    groups: [
      {
        items: [
          { id: 'perf-vitals', label: 'Core Web Vitals', path: 'performance/vitals' },
          { id: 'perf-pagespeed', label: 'PageSpeed', path: 'performance/pagespeed' },
        ],
      },
    ],
  },
  {
    id: 'ai',
    label: 'IA',
    icon: Bot,
    path: 'ai/analyst',
    children: [
      { id: 'ai-analyst', label: 'AI Analyst', path: 'ai/analyst' },
      { id: 'ai-llm', label: 'Visibilit\u00e9 LLM', path: 'ai/llm' },
      { id: 'ai-overviews', label: 'AI Overviews', path: 'ai/overviews', disabled: true, badge: 'Bientot' },
    ],
    groups: [
      {
        items: [
          { id: 'ai-analyst', label: 'AI Analyst', path: 'ai/analyst' },
          { id: 'ai-llm', label: 'Visibilit\u00e9 LLM', path: 'ai/llm' },
          { id: 'ai-overviews', label: 'AI Overviews', path: 'ai/overviews', disabled: true, badge: 'Bientot' },
        ],
      },
    ],
  },
  {
    id: 'local',
    label: 'Local',
    icon: MapPin,
    path: 'local/insights',
    children: [
      { id: 'local-insights', label: 'Insights GBP', path: 'local/insights' },
      { id: 'local-maps', label: 'Positions Maps', path: 'local/maps' },
      { id: 'local-reputation', label: 'R\u00e9putation', path: 'local/reputation' },
      { id: 'local-posts', label: 'Publications', path: 'local/posts' },
      { id: 'local-updates', label: 'Mises \u00e0 jour', path: 'local/updates' },
    ],
    groups: [
      {
        items: [
          { id: 'local-insights', label: 'Insights GBP', path: 'local/insights' },
          { id: 'local-maps', label: 'Positions Maps', path: 'local/maps' },
          { id: 'local-reputation', label: 'R\u00e9putation', path: 'local/reputation' },
          { id: 'local-posts', label: 'Publications', path: 'local/posts' },
          { id: 'local-updates', label: 'Mises \u00e0 jour', path: 'local/updates' },
        ],
      },
    ],
  },
  {
    id: 'analytics',
    label: 'Analytics',
    icon: BarChart3,
    path: 'analytics/audience',
    children: [
      { id: 'analytics-audience', label: 'Audience', path: 'analytics/audience' },
      { id: 'analytics-sources', label: 'Sources de trafic', path: 'analytics/sources' },
      { id: 'analytics-search', label: 'Visibilite recherche', path: 'analytics/search', disabled: true, badge: 'Bientot' },
    ],
    groups: [
      {
        items: [
          { id: 'analytics-audience', label: 'Audience', path: 'analytics/audience' },
          { id: 'analytics-sources', label: 'Sources de trafic', path: 'analytics/sources' },
          { id: 'analytics-search', label: 'Visibilite recherche', path: 'analytics/search', disabled: true, badge: 'Bientot' },
        ],
      },
    ],
  },
  {
    id: 'competitors',
    label: 'Concurrents',
    icon: Users,
    path: 'competitors/added',
    comingSoon: true,
    children: [
      { id: 'comp-added', label: 'Concurrents ajoutes', path: 'competitors/added', disabled: true, badge: 'Bientot' },
      { id: 'comp-share', label: 'Part de voix', path: 'competitors/share', disabled: true, badge: 'Bientot' },
      { id: 'comp-serp', label: 'Concurrents SERP', path: 'competitors/serp', disabled: true, badge: 'Bientot' },
    ],
    groups: [
      {
        items: [
          { id: 'comp-added', label: 'Concurrents ajoutes', path: 'competitors/added', disabled: true, badge: 'Bientot' },
          { id: 'comp-share', label: 'Part de voix', path: 'competitors/share', disabled: true, badge: 'Bientot' },
          { id: 'comp-serp', label: 'Concurrents SERP', path: 'competitors/serp', disabled: true, badge: 'Bientot' },
        ],
      },
    ],
  },
  {
    id: 'backlinks',
    label: 'Backlinks',
    icon: Link2,
    disabled: true,
    comingSoon: true,
    children: [
      { id: 'bl-checker', label: 'Verificateur', path: 'backlinks/checker', disabled: true, badge: 'V2' },
      { id: 'bl-monitor', label: 'Suivi', path: 'backlinks/monitor', disabled: true, badge: 'V2' },
    ],
    groups: [
      {
        items: [
          { id: 'bl-checker', label: 'Verificateur', path: 'backlinks/checker', disabled: true, badge: 'V2' },
          { id: 'bl-monitor', label: 'Suivi', path: 'backlinks/monitor', disabled: true, badge: 'V2' },
        ],
      },
    ],
  },
  {
    id: 'insights',
    label: 'Insights',
    icon: Lightbulb,
    path: 'insights',
    disabled: true,
    badge: 'Bientot',
  },
  {
    id: 'action-plan',
    label: "Plan d'actions",
    icon: ClipboardList,
    path: 'action-plan',
    disabled: true,
    badge: 'Bientot',
  },
  {
    id: 'changes',
    label: 'Suivi des modifications',
    icon: FileEdit,
    path: 'changes',
    disabled: true,
    badge: 'Bientot',
  },
  {
    id: 'reports',
    label: 'Rapports',
    icon: FileText,
    path: 'reports',
    children: [
      { id: 'reports-list', label: 'Mes rapports', path: 'reports' },
      { id: 'reports-snapshots', label: 'Snapshots', path: 'snapshots' },
      { id: 'reports-templates', label: 'Templates', path: 'report-templates' },
    ],
    groups: [
      {
        items: [
          { id: 'reports-list', label: 'Mes rapports', path: 'reports' },
          { id: 'reports-snapshots', label: 'Snapshots', path: 'snapshots' },
          { id: 'reports-templates', label: 'Templates', path: 'report-templates' },
        ],
      },
    ],
  },
  {
    id: 'settings',
    label: 'Parametres',
    icon: Settings,
    path: 'settings',
    groups: [
      {
        items: [
          { id: 'settings-project', label: 'Parametres projet', path: 'settings' },
          { id: 'settings-engines', label: 'Moteurs de recherche', path: 'settings/search-engines' },
          { id: 'settings-sources', label: 'Sources de donnees', path: 'settings/data-sources' },
        ],
      },
    ],
  },
]

export const RAIL_GROUPS: { items: string[] }[] = [
  { items: ['overview'] },
  { items: ['audit', 'rankings', 'performance', 'ai', 'local', 'analytics'] },
  { items: ['competitors', 'backlinks'] },
  { items: ['reports', 'settings'] },
]

export const BOTTOM_NAV: NavItem[] = [
  {
    id: 'admin-users',
    label: 'Accès utilisateurs',
    icon: ShieldCheck,
    path: '/admin/users',
    adminOnly: true,
  },
  {
    id: 'admin-project-access',
    label: 'Accès projets',
    icon: ShieldCheck,
    path: '/admin/project-access',
    adminOnly: true,
  },
  {
    id: 'costs',
    label: 'Coûts API',
    icon: DollarSign,
    path: '/costs',
    adminOnly: true,
  },
  {
    id: 'global-db',
    label: 'Global DB',
    icon: Database,
    path: '/admin/global-database',
    adminOnly: true,
  },
  {
    id: 'admin-users',
    label: 'Utilisateurs',
    icon: Users,
    path: '/admin/users',
    adminOnly: true,
  },
  {
    id: 'api-keys',
    label: 'Cles API',
    icon: Key,
    path: '/settings/api-keys',
  },
  {
    id: 'settings',
    label: 'Parametres',
    icon: Settings,
    path: 'settings',
  },
]
